import { InformationIcon } from 'assets/icons'

interface EmptySectionProps {
  section: keyof typeof SECTION_TEXTS
  className?: string
}

export const SECTION_TEXTS = {
  ACTIVE_ADVANCES: {
    title: 'No tenés adelantos activos',
    description: 'Pedí uno y comprá lo que quieras con tu tarjeta Wayni.'
  },
  PAID_ADVANCES: {
    title: 'No tenés adelantos finalizados',
    description: 'Pedí uno y comprá lo que quieras con tu tarjeta Wayni.'
  },
  ACTIVE_LOANS: {
    title: 'No tenés préstamos activos',
    description: 'Solicitá uno y administrá tus finanzas'
  },
  PAID_LOANS: {
    title: 'No tenés préstamos finalizados',
    description: 'Solicitá uno y administrá tus finanzas'
  },
  MOVEMENTS: {
    title: null,
    description: 'No existen movimientos para el período seleccionado'
  },
  CONTACTS: {
    title: null,
    description: 'No tenés contactos agendados.'
  }
}

const EmptySection = ({ section, className = '' }: EmptySectionProps) => (
  <div
    className={`bg-white flex flex-col items-center p-4 rounded-md border border-gray-500 w-full mt-4 ${className}`}
  >
    <span className='rounded-full h-10 w-10 items-center justify-center bg-blue-100 flex mb-1'>
      <InformationIcon />
    </span>
    {SECTION_TEXTS[section].title ? (
      <p className='text-xs font-bold mt-2'>{SECTION_TEXTS[section].title}</p>
    ) : null}
    {SECTION_TEXTS[section].description ? (
      <p className='text-2xs text-gray-900 font-medium mt-1'>
        {SECTION_TEXTS[section].description}
      </p>
    ) : null}
  </div>
)

export default EmptySection
